var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-stage"},[_c('div',{staticClass:"flex align-items margin-bottom small-padding-bottom"},[_c('h1',[_vm._v("Uniconta state: "+_vm._s(_vm.unicontaState))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }